import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=c5a9ac84&scoped=true"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"
import style0 from "./TicketCard.vue?vue&type=style&index=0&id=c5a9ac84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a9ac84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5a9ac84')) {
      api.createRecord('c5a9ac84', component.options)
    } else {
      api.reload('c5a9ac84', component.options)
    }
    module.hot.accept("./TicketCard.vue?vue&type=template&id=c5a9ac84&scoped=true", function () {
      api.rerender('c5a9ac84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/modules/TicketCard.vue"
export default component.exports